import React from 'react';
import { FileText, Radio, Eye, Clock } from 'lucide-react';

// Caixa de exemplo — mesmo visual bg-blue-50/border-blue-200 já usado nos
// avisos de dentro do próprio ConfigurarEnqueteForm.js, só reaproveitado
// aqui como "Exemplo:" pra manter a explicação didática, não abstrata.
const Exemplo = ({ children }) => (
  <div className="text-xs text-blue-700 bg-blue-50 border border-blue-200 rounded-lg px-3 py-2 mt-2">
    <span className="font-semibold">Exemplo: </span>{children}
  </div>
);

const Secao = ({ icone: Icone, titulo, children }) => (
  <section>
    <h3 className="flex items-center gap-2 text-sm font-semibold text-gray-900 mb-2">
      <Icone className="w-4 h-4 text-primary-600" /> {titulo}
    </h3>
    <div className="text-sm text-gray-600 space-y-2">{children}</div>
  </section>
);

// Conteúdo do modal de ajuda da aba "Geral" (ConfigurarEnqueteForm.js) —
// explica campo por campo, com regra + exemplo concreto pra cada um. Só
// cobre o que está NESSA aba — "Capa" e "Personalizar Fundo" têm suas
// próprias explicações inline (preview ao vivo já cumpre esse papel lá).
const AjudaConfiguracoesGeraisModal = () => (
  <div className="space-y-6">
    <Secao icone={FileText} titulo="Título e Descrição">
      <p>
        Aparecem no topo da página pública, acima das perguntas. O título é obrigatório; a descrição é opcional
        e só aparece se você preencher algo.
      </p>
    </Secao>

    <Secao icone={Eye} titulo="Status">
      <p>Controla se a enquete aceita voto — três estados:</p>
      <ul className="list-disc pl-5 space-y-1">
        <li><strong>Rascunho</strong> — enquete em construção. Se ela também estiver marcada como pública (esse é outro controle, o toggle na linha da lista em "Gerenciar Enquetes"), o link funciona como prévia: dá pra ver as perguntas, mas votar e ver resultado ficam bloqueados até virar "Publicada".</li>
        <li><strong>Publicada</strong> — votação aberta pra qualquer visitante que acessar o link.</li>
        <li><strong>Encerrada</strong> — não aceita mais voto. Você pode definir isso manualmente aqui, ou deixar acontecer sozinho pelo campo "Data e hora de encerramento" logo abaixo.</li>
      </ul>
      <Exemplo>
        Você está montando uma enquete de 10 perguntas e quer que seu chefe revise antes de abrir pro público.
        Deixa em <strong>Rascunho</strong> + marca como pública na lista, manda o link pra ele revisar as perguntas,
        e só muda pra <strong>Publicada</strong> quando estiver tudo certo.
      </Exemplo>
    </Secao>

    <Secao icone={Radio} titulo="Mostrar resultado">
      <p>Controla quando quem vota consegue ver os números da enquete:</p>
      <ul className="list-disc pl-5 space-y-1">
        <li><strong>Tempo real</strong> — assim que a pessoa vota, ela já vê o resultado atualizado (com todos os votos até aquele momento) na mesma tela, sem precisar esperar a enquete encerrar.</li>
        <li><strong>Só após encerrar</strong> — ninguém vê resultado nenhum, nem quem já votou, até o status virar "Encerrada" (manual ou automático).</li>
        <li><strong>Nunca mostrar</strong> — resultado fica sempre invisível pro público, mesmo depois de encerrada. Os números continuam disponíveis só pra você, no painel de Resultados do admin.</li>
      </ul>
      <Exemplo>
        Numa enquete de "qual local sediar o evento?", usar <strong>Só após encerrar</strong> evita que ver o
        primeiro colocado influencie quem ainda não votou — o resultado só aparece pra todo mundo de uma vez, no final.
      </Exemplo>
    </Secao>

    <Secao icone={Clock} titulo="Data e hora de encerramento">
      <p>
        Opcional. Quando esse horário passa, o status muda sozinho pra "Encerrada" — você não precisa entrar e
        trocar manualmente. Deixando em branco, a enquete nunca fecha sozinha, só se você mudar o Status
        pra "Encerrada" aqui mesmo.
      </p>
      <p>
        Os botões de atalho ("Em 1 hora", "Em 24 horas"...) preenchem os dois campos de uma vez a partir de agora —
        use quando quiser um prazo relativo, sem precisar contar data/hora de cabeça.
      </p>
      <p className="text-xs text-gray-500">
        O horário é sempre em Corumbá (UTC-4), não importa de onde você está acessando o painel no momento de configurar.
      </p>
      <Exemplo>
        Você publicou uma enquete numa sexta e quer que ela feche sozinha no domingo à noite, sem precisar lembrar
        de voltar no site. Clica em <strong>"Em 3 dias"</strong> (ou digita a data/hora manualmente) e salva —
        no momento em que esse horário passar, ninguém mais consegue votar.
      </Exemplo>
    </Secao>
  </div>
);

export default AjudaConfiguracoesGeraisModal;
